import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import BookingModal from '../components/BookingModal';

const About = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const aboutSectionRef = useRef(null);
  const [imageFixed, setImageFixed] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (aboutSectionRef.current) {
        const rect = aboutSectionRef.current.getBoundingClientRect();
        // When about section ends, unfix the image
        setImageFixed(rect.bottom > 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({ firstName: '', lastName: '', email: '', message: '' });
    }, 3000);
  };

  const locations = [
    {
      name: 'BLR Nail Club',
      branch: 'RR NAGAR',
      logo: '/logo.png',
      logoInvert: false,
      address: 'N2VK Arcade, 1154, Jawaharlal Nehru Rd, BEML Layout 3rd Stage, Rajarajeshwari Nagar, Bengaluru, Karnataka 560098',
      phone: '+91-7204602211',
      phoneRaw: '+917204602211',
      timings: '10:00 AM - 8:00 PM',
      days: 'Monday - Sunday',
      image: 'https://static.wixstatic.com/media/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg/v1/fill/w_480,h_900,al_c,q_85,enc_avif,quality_auto/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg',
      slug: 'rr-nagar',
      mapLink: 'https://maps.google.com/?q=BLR+Nail+club+-+RR+nagar',
    },
    {
      name: 'Nailashes',
      branch: 'BASAVESHWARNAGAR',
      logo: '/logo.png',
      logoInvert: false,
      address: 'LGF, No. 9, East Jayanagar, West of Chord Road 1st Stage, Basaveshwar Nagar, Bengaluru, Karnataka 560079',
      phone: '+91-9611560759',
      phoneRaw: '+919611560759',
      timings: '10:30 AM - 10:00 PM',
      days: 'Monday - Sunday',
      image: 'https://static.wixstatic.com/media/486953_3b99a1aec9184dca9d620eaa8540c766~mv2.jpeg/v1/fill/w_480,h_900,al_c,q_85,enc_avif,quality_auto/486953_3b99a1aec9184dca9d620eaa8540c766~mv2.jpeg',
      slug: 'nailashes-basaveshwarnagar',
      directUrl: '/nailashes-basaveshwarnagar',
      mapLink: 'https://www.google.com/maps/place/Nailashes+Basaveshwarnagar',
    },
    {
      name: 'Benefits Salon',
      branch: 'RR NAGAR',
      logo: '/benefits-logo.png',
      logoInvert: true,
      address: 'RR Nagar, Bengaluru, Karnataka',
      phone: '+91-7204602211',
      phoneRaw: '+917204602211',
      timings: '10:00 AM - 8:00 PM',
      days: 'Monday - Sunday',
      image: 'https://static.wixstatic.com/media/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg/v1/fill/w_480,h_900,al_c,q_85,enc_avif,quality_auto/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg',
      slug: 'benefits-rr-nagar',
      mapLink: 'https://maps.google.com/?q=Benefits+Salon+RR+Nagar+Bengaluru',
    },
    {
      name: 'Benefits Salon',
      branch: 'BASAVESHWARNAGAR',
      logo: '/benefits-logo.png',
      logoInvert: true,
      address: 'Basaveshwarnagar, Bengaluru, Karnataka',
      phone: '+91-9611560759',
      phoneRaw: '+919611560759',
      timings: '10:00 AM - 8:00 PM',
      days: 'Monday - Sunday',
      image: 'https://static.wixstatic.com/media/5df0bd_dab9ff5017f643f3bb0e5441471366df~mv2.jpeg/v1/fill/w_480,h_900,al_c,q_85,enc_avif,quality_auto/5df0bd_dab9ff5017f643f3bb0e5441471366df~mv2.jpeg',
      slug: 'benefits-basaveshwarnagar',
      mapLink: 'https://maps.google.com/?q=Benefits+Salon+Basaveshwarnagar+Bengaluru',
    },
    {
      name: 'BLR Nail Club',
      branch: 'CSK MALL',
      logo: '/logo.png',
      logoInvert: false,
      address: 'Shop no 50, 1st Floor, CSK Mall, Gunjur Palya, Bengaluru, Karnataka 560087',
      phone: '+91-9741763377',
      phoneRaw: '+919741763377',
      timings: '10:00 AM - 8:00 PM',
      days: 'Monday - Sunday',
      image: 'https://static.wixstatic.com/media/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg/v1/fill/w_480,h_900,al_c,q_85,enc_avif,quality_auto/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg',
      slug: 'csk-mall',
      mapLink: 'https://share.google/WYlU8jvsIsMtxQpaL',
    },
  ];

  return (
    <>
      <Helmet>
        <title>About Us - BLR Nail Club | Premium Nail & Beauty Salon in Bangalore</title>
        <meta name="description" content="BLR Nail Club is Bangalore's premier nail and beauty destination. Learn about our story, expert team, and 3 convenient locations in RR Nagar, Basaveshwarnagar & Varthur." />
        <meta name="keywords" content="about BLR Nail Club, nail salon Bangalore, beauty salon story, nail artists Bangalore, RR Nagar salon, Basaveshwarnagar beauty" />
        <link rel="canonical" href="https://www.blrnailclub.in/about" />
        <meta property="og:title" content="About BLR Nail Club - Premium Nail Salon Bangalore" />
        <meta property="og:description" content="Discover our story and expert team at BLR Nail Club - Bangalore's leading nail & beauty studio." />
        <meta property="og:url" content="https://www.blrnailclub.in/about" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About BLR Nail Club",
            "description": "BLR Nail Club is a premium beauty destination in Bengaluru offering nail, lash, PMU, and salon services.",
            "url": "https://www.blrnailclub.in/about",
            "mainEntity": {
              "@type": "BeautySalon",
              "name": "BLR Nail Club",
              "numberOfEmployees": "12+",
              "foundingDate": "2020"
            }
          })}
        </script>
      </Helmet>
      
      <main className="bg-black" data-testid="about-page">
      {/* About Section - Split layout with fixed image */}
      <section ref={aboutSectionRef} className="relative min-h-screen">
        {/* Left - Fixed Image */}
        <div 
          className={`lg:w-1/2 lg:h-screen lg:left-0 lg:top-0 ${
            imageFixed ? 'lg:fixed' : 'lg:absolute lg:bottom-0'
          }`}
          style={{ zIndex: 1 }}
        >
          <img
            src="https://static.wixstatic.com/media/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg/v1/fill/w_950,h_1100,al_c,q_85,enc_avif,quality_auto/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg"
            alt="BLR Nail Club Interior"
            className="w-full h-[50vh] lg:h-screen object-cover"
          />
        </div>

        {/* Right - Scrolling Content */}
        <div className="lg:w-1/2 lg:ml-[50%] bg-black flex items-center min-h-screen relative z-10">
          <div className="px-8 md:px-16 py-16 lg:py-24">
            <h3 className="text-[#B8860B] text-xs tracking-[0.3em] uppercase mb-8 font-light">ABOUT US</h3>
            <p className="text-white text-sm md:text-base leading-[1.8] mb-6 font-light">
              BLR Nail Club is a premium beauty destination in Bengaluru, offering a complete range of nail, 
              lash, PMU, and salon services under one roof. Designed for a modern and luxurious experience, 
              we focus on quality, hygiene, and personalized care for every client.
            </p>
            <p className="text-white/80 text-sm leading-[1.8] mb-6 font-light">
              We specialize in nail extensions, gel polish, and custom nail art, along with professional 
              lash extensions to enhance your natural beauty. Our studio also provides PMU (Permanent Makeup) 
              services including brows and lip tinting, tailored to suit individual features.
            </p>
            <p className="text-white/80 text-sm leading-[1.8] mb-6 font-light">
              In addition, we offer a full range of salon services including haircuts, hair coloring, 
              styling, and beauty treatments — making BLR Nail Club your go-to destination for complete 
              grooming and self-care.
            </p>
            <p className="text-white/60 text-xs leading-[1.8] mb-10 font-light italic">
              We use high-quality products, follow strict hygiene standards, and stay updated with the 
              latest beauty trends to ensure every visit feels premium and satisfying.
            </p>
            <a
              href="https://www.khoobventures.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block border border-[#B8860B] text-[#B8860B] px-8 py-4 text-xs tracking-[0.2em] uppercase font-light hover:bg-[#B8860B] hover:text-black transition-all duration-300 text-center"
            >
              Book Your Experience Now
            </a>
          </div>
        </div>
      </section>

      {/* Locations Section - Horizontal scroll */}
      <section className="bg-black relative z-20" id="locations">
        <div className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide">
          {locations.map((location, index) => (
            <Link
              key={index}
              to={location.directUrl || `/location/${location.slug}`}
              className="flex-shrink-0 w-[85vw] md:w-[50vw] lg:w-[25vw] snap-start relative group cursor-pointer block"
            >
              <img
                src={location.image}
                alt={`${location.name} - ${location.branch}`}
                className="w-full h-[100vh] object-cover"
              />

              <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-6 bg-black/40 group-hover:bg-black/50 transition-all duration-300">
                {/* Logo */}
                <img 
                  src={location.logo}
                  alt={`${location.name} Logo`}
                  className="h-12 md:h-14 w-auto mb-4"
                  style={location.logoInvert ? { filter: 'invert(1) brightness(2)' } : {}}
                />
                <h3 className="text-white text-lg md:text-xl tracking-[0.25em] uppercase font-light mb-2">
                  {location.name}
                </h3>
                <h4 className="text-[#B8860B] text-sm tracking-[0.2em] uppercase font-light mb-12">
                  {location.branch}
                </h4>

                <div className="mb-6">
                  <p className="text-[#B8860B] text-[10px] tracking-[0.2em] uppercase mb-2">Address</p>
                  <p className="text-white/90 text-xs font-light leading-relaxed max-w-[200px]">
                    {location.address}
                  </p>
                </div>

                <div className="mb-6">
                  <p className="text-[#B8860B] text-[10px] tracking-[0.2em] uppercase mb-2">Contact</p>
                  <p className="text-white text-sm font-light">
                    {location.phone}
                  </p>
                </div>

                <div className="mb-10">
                  <p className="text-[#B8860B] text-[10px] tracking-[0.2em] uppercase mb-2">Timings</p>
                  <p className="text-white/80 text-xs font-light">{location.days}</p>
                  <p className="text-white text-xs font-light">{location.timings}</p>
                </div>

                <span
                  className="inline-block border border-[#B8860B] text-[#B8860B] px-6 py-3 text-[10px] tracking-[0.2em] uppercase font-light group-hover:bg-[#B8860B] group-hover:text-black transition-all duration-300"
                >
                  View Details
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Contact Us Section - White Background */}
      <section className="bg-white py-20" id="contact">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Left - Contact Info */}
            <div>
              <h2 className="text-black text-lg font-light tracking-wide mb-8">Contact Us</h2>
              <a 
                href="mailto:info@blrnailclub.in"
                className="text-black/70 text-sm font-light hover:text-[#B8860B] transition-colors block mb-8 underline"
              >
                info@blrnailclub.in
              </a>
              
              {/* Social Links */}
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/blrnailclub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-full bg-black/10 flex items-center justify-center hover:bg-[#B8860B] transition-all duration-300 text-black hover:text-white"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/blr_nailclub/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-full bg-black/10 flex items-center justify-center hover:bg-[#B8860B] transition-all duration-300 text-black hover:text-white"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Right - Book Appointment */}
            <div className="flex flex-col justify-center">
              <h3 className="text-2xl font-light text-black mb-4">Book Your Appointment</h3>
              <p className="text-black/60 text-sm font-light mb-8 leading-relaxed">
                Ready to experience luxury nail care? Book your appointment now and let our expert technicians pamper you.
              </p>
              <button
                onClick={() => setIsBookingModalOpen(true)}
                className="bg-[#B8860B] text-black px-8 py-4 text-sm tracking-[0.2em] uppercase font-medium hover:bg-[#9A7B0A] transition-all duration-300 w-fit"
                data-testid="about-book-btn"
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Social Bar - White background */}
      <section className="bg-white py-4 border-t border-black/10">
        <div className="max-w-5xl mx-auto px-6 md:px-12 flex justify-end gap-4">
          <a
            href="https://wa.me/917204602211"
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 rounded-full bg-black/5 flex items-center justify-center hover:bg-[#B8860B] transition-all duration-300 text-black/40 hover:text-white"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
          </a>
          <a
            href="https://www.instagram.com/blr_nailclub/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 rounded-full bg-black/5 flex items-center justify-center hover:bg-[#B8860B] transition-all duration-300 text-black/40 hover:text-white"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
          </a>
          <a
            href="https://www.facebook.com/blrnailclub"
            target="_blank"
            rel="noopener noreferrer"
            className="w-8 h-8 rounded-full bg-black/5 flex items-center justify-center hover:bg-[#B8860B] transition-all duration-300 text-black/40 hover:text-white"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
        </div>
      </section>

      {/* Hide scrollbar */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>

      {/* Booking Modal */}
      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} />
    </main>
    </>
  );
};

export default About;
